import React, { useEffect } from "react";
// AOS Animation NPM
import AOS from "aos";
import "aos/dist/aos.css";
import './App.scss';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

// Main Layout and Pages
import { Layout } from './components/layouts/Layout';
import { Home } from './pages/Homepage/Home';
import { AboutUs } from './pages/AboutUs';
import { ContactUs } from './pages/ContactUs';
import { Communities } from './pages/Communities';
import { Features } from './pages/Features';
import { Pricing } from './pages/Pricing';
import { PageNotFound } from './pages/PageNotFound';
// import OtpVerification from './pages/authentication/OtpVerification';
import Privacy from './pages/PrivacyPolicy/Privacy';
import TermsOfService from './pages/TermsOfService';
import RefundPolicy from './pages/RefundPolicy';
import ResetPassword from './pages/ResetPassword';
import ScrollToTopOnRouteChange from "./components/ScrollToTopOnRouteChange";

function App() {
  // AOS Animations
  useEffect(() => {
    AOS.init({
      offset: 50,
      duration: 800,
      easing: 'ease-in-out',
      once: true
    }); // set options as needed
  }, []);

  return (
    <>
      <BrowserRouter>
        {/* When redirect to any page, page should load from top */}
        <ScrollToTopOnRouteChange />

        <Routes>

          {/* Reset Password Route - Outside Layout */}
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Main Layout Routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<AboutUs />} />
            <Route path="communities" element={<Communities />} />
            <Route path="features" element={<Features />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="contact" element={<ContactUs />} />
            <Route path="privacy-policy" element={<Privacy />} />
            <Route path="terms-of-service" element={<TermsOfService />} />
            <Route path="refund-policy" element={<RefundPolicy />} />
            <Route path="*" element={<PageNotFound />} />
          </Route>

        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
